var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWarningCircle = function SvgIconWarningCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8A700",
    fillRule: "evenodd",
    d: "M11.459 4.81a1.458 1.458 0 0 0-2.917 0v7.224a1.458 1.458 0 0 0 2.917 0zM10 17.65a1.458 1.458 0 1 0 0-2.916 1.458 1.458 0 0 0 0 2.917",
    clipRule: "evenodd"
  })));
};
export default SvgIconWarningCircle;